/**
 * Labstep
 *
 * @module screens/Protocol/Show
 * @desc Protocol show
 */

import { DocumentHead } from 'labstep-web/core/DocumentHead';
import { Redirect } from 'labstep-web/core/Redirect';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { Protocol } from 'labstep-web/models/protocol.model';
import ScreensMasterShow from 'labstep-web/screens/Master/Show';
import { ProtocolShowCenter as Center } from 'labstep-web/screens/Protocol/Show/Center';
import { ScreensProtocolShowRight as Right } from 'labstep-web/screens/Protocol/Show/Right';
import type React from 'react';
import type { IShowProps } from './types';

export const Show: React.FC<IShowProps> = ({ protocol }) => {
  if (protocol.collection.deleted_at) {
    return (
      <Redirect
        to="protocol_collection_show"
        params={{ id: protocol.collection.id }}
      />
    );
  }

  return (
    <>
      <DocumentHead title={protocol.nameAndVersion} />
      <ScreensMasterShow
        entity={protocol.collection}
        center={<Center protocol={protocol} />}
        right={<Right protocol={protocol} />}
      />
    </>
  );
};

export const ShowContainer: React.FC<any> = (props) => (
  <ReadOnMountHOC
    type="entity"
    loading={{ loader: 'full_screen' }}
    entityName={Protocol.entityName}
    id={props.match.params.id}
    children={({ entity: protocol }) => (
      <Show protocol={protocol} {...props} />
    )}
  />
);
